<div class="container">

  <mat-tab-group [selectedIndex]="selected.value" (selectedTabChange)="back($event)">
    <mat-tab label="Historial combustible">
      <div style="width: 100%; margin-top: 30px;">
        <data-table [titleExcelFile]="'histórico_combustible'" [columns]='columnasFO' [configuration]='configurationFO'
          [reloadTable]='recargarTablaFO' [params]='params' [url]='urlTableFO' (view)='viewDetail($event)'
          (edit)='editFO($event)' (print)='print($event)' [headerFilters]="headerFilters"
        [headerFileXlsm]="headerFileXlsm"></data-table>
      </div>


    </mat-tab>

    @if (selected.value == 1) {
      <mat-tab label="Detalle">
        <div class="containerCard">
          <mat-card appearance="outlined" style="background-color: #ffffff7a;">
            <mat-card-content class="mat-body-1">
              <h2><strong>Equipo: {{data.code}}</strong></h2>
              <h3>Fecha: {{data.date}}</h3>
              <h3>Solicita: {{data.requestsName}}</h3>
              <h3>Lugar: {{data.place}}</h3>
              <h3>Tipo de Combustible: {{data.fuelType}}</h3>
              <h3>Galones: {{data.gallons}}</h3>
              <h3>Precio Galón: {{data.gallonPrice | thousandSeparator}}</h3>
              <h3>Precio Total: {{data.totalPrice | thousandSeparator}}</h3>
              <h3>Número Factura: {{data.billNumber}}</h3>
              <h3>Orden Venta: {{data.salesOrder}}</h3>
              <h3>Descripción: {{data.description}}</h3>
              <h3>Medidor (horas/km/ciclos): {{data.orderOdometer | thousandSeparator}}</h3>
              <hr>
                <h2>Autorizó: {{data.authorizeName}}</h2>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-tab>
      }
    </mat-tab-group>

  </div>
